import { render, staticRenderFns } from "./WpZoom.vue?vue&type=template&id=367a14fe&"
import script from "./WpZoom.vue?vue&type=script&lang=js&"
export * from "./WpZoom.vue?vue&type=script&lang=js&"
import style0 from "./WpZoom.vue?vue&type=style&index=0&id=367a14fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports